import React, { Component } from 'react';
import DatePicker from 'react-datepicker';

export default class UpdateExecutionDateModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            date: null,
        };
    }

    handleDateChange = (date) => {
        this.setState({
            date: date,
        });
    };

    stopPropagation = (e) => {
        e.stopPropagation();
    };

    updateExecutionDate = (e) => {
        e.stopPropagation();

        let formData = new FormData();
        formData.append('date', moment(this.state.date).format('YYYY/MM/DD'));
        formData.append('ids', JSON.stringify(this.props.selectedJobs));

        axios
            .post(`/jobs/update-execution-date`, formData)
            .then((res) => {
                toastr.success('Updated planned date(s)');
                window.location.reload();
            })
            .catch((err) => {
                toastr.error('There was a problem, please try again');
            });
    };

    render() {
        return (
            <div
                className="admin-notes-modal"
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                <div className="admin-notes-modal-body">
                    <div className="admin-modal-content">
                        <h4>{`Update Planned Date for ${this.props.selectedJobs.length} job(s)`}</h4>
                        <hr />
                        <div className="form-group">
                            <label htmlFor="date">Date</label>
                            <DatePicker
                                selected={this.state.date}
                                onChange={(date) => this.handleDateChange(date)}
                                onClick={(e) => this.stopPropagation(e)}
                                minDate={new Date()}
                                dateFormat="dd/MM/yyyy"
                                className="form-control"
                                placeholderText="Select Planned Date"
                            />
                        </div>
                        <div className="form-group">
                            <button
                                className="btn btn-cw-primary ml-2"
                                onClick={(e) => this.updateExecutionDate(e)}
                                disabled={this.state.date === null}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                    <hr />
                    <div className="admin-notes-modal-footer">
                        <button className="btn btn-cw-primary" onClick={(e) => this.props.onHide(e, false)}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
